import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faUserPlus, faUserCheck, faWeightHanging } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const CustomerOverview = ({ data }) => {
    const { t } = useTranslation();
    if (!data) return null;

    const strings = t('customerAnalytics.overview', { returnObjects: true });

    const summaryMetrics = [
        {
            label: strings.activeCustomers,
            value: data.total_active_customers?.toLocaleString('en-IN') ?? '—',
            icon: faUsers,
            color: '#0891b2',
            bg: '#ecfeff',
        },
        {
            label: strings.newCustomers,
            value: data.new_customers?.toLocaleString('en-IN') ?? '—',
            icon: faUserPlus,
            color: '#059669',
            bg: '#ecfdf5',
        },
        {
            label: strings.returningCustomers,
            value: data.returning_customers?.toLocaleString('en-IN') ?? '—',
            icon: faUserCheck,
            color: '#7c3aed',
            bg: '#f5f3ff',
        },
    ];

    const weightMetrics = [
        {
            label: strings.newWeightTons,
            value: `${parseFloat(data.new_customer_weight_tons || 0).toFixed(3)} T`,
            icon: faWeightHanging,
            color: '#059669',
            bg: '#ecfdf5',
        },
        {
            label: strings.returningWeightTons,
            value: `${parseFloat(data.returning_customer_weight_tons || 0).toFixed(3)} T`,
            icon: faWeightHanging,
            color: '#7c3aed',
            bg: '#f5f3ff',
        },
    ];

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            {/* Customer Summary */}
            <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                    <div style={{ width: 3, height: 16, borderRadius: 2, backgroundColor: '#0891b2' }} />
                    <span style={{ fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.6px' }}>
                        Customer Summary
                    </span>
                </div>
                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                    {summaryMetrics.map((m) => (
                        <div
                            key={m.label}
                            style={{
                                flex: '1 1 160px',
                                minWidth: 160,
                                backgroundColor: '#ffffff',
                                border: '1px solid #f3f4f6',
                                borderRadius: 12,
                                padding: '14px 16px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
                            }}
                        >
                            <div style={{ width: 36, height: 36, borderRadius: 10, backgroundColor: m.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: m.color, fontSize: 14, flexShrink: 0 }}>
                                <FontAwesomeIcon icon={m.icon} />
                            </div>
                            <div>
                                <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 600, marginBottom: 2 }}>{m.label}</div>
                                <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', lineHeight: 1 }}>{m.value}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Weight Summary */}
            <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                    <div style={{ width: 3, height: 16, borderRadius: 2, backgroundColor: '#d97706' }} />
                    <span style={{ fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.6px' }}>
                        Weight Dispatched
                    </span>
                </div>
                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                    {weightMetrics.map((m) => (
                        <div
                            key={m.label}
                            style={{
                                flex: '1 1 200px',
                                minWidth: 200,
                                backgroundColor: '#ffffff',
                                border: '1px solid #f3f4f6',
                                borderRadius: 12,
                                padding: '14px 16px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
                            }}
                        >
                            <div style={{ width: 36, height: 36, borderRadius: 10, backgroundColor: m.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: m.color, fontSize: 14, flexShrink: 0 }}>
                                <FontAwesomeIcon icon={m.icon} />
                            </div>
                            <div>
                                <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 600, marginBottom: 2 }}>{m.label}</div>
                                <div style={{ fontSize: 20, fontWeight: 800, color: '#111827', lineHeight: 1 }}>{m.value}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CustomerOverview;
